import { config } from '../config.js';

/**
 * `1.0.0` → `v1.0.0`, but `dev` stays `dev` — a local dev server has no
 * release to name, and `vdev` reads as a typo rather than an absence.
 */
export function formatVersion(version: string): string {
  return version === 'dev' ? version : `v${version}`;
}

/**
 * `2026-08-09T12:35:31Z` → `2026-08-09 12:35 UTC`.
 *
 * Deliberately a string trim rather than Date + toLocaleString: the stamp is
 * generated in UTC by the deploy script, and rendering it in the reader's
 * locale would silently shift the number an admin is comparing against a
 * deploy log. Anything unparseable is passed through rather than swallowed.
 */
export function formatBuildTime(iso: string): string {
  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):\d{2}Z$/.exec(iso);
  return match ? `${match[1]} ${match[2]} UTC` : iso;
}

/**
 * The operator line: `v1.0.0 · built 2026-08-09 12:35 UTC`, or the version
 * alone when there is no stamp. Composed here rather than in the JSX so the
 * empty-buildTime branch is testable and Usage.tsx stays a pure render.
 */
export function formatBuildStamp(version: string, buildTime: string): string {
  const shown = formatVersion(version);
  return buildTime ? `${shown} · built ${formatBuildTime(buildTime)}` : shown;
}

/**
 * The build the browser actually loaded — not what is currently deployed.
 * That is the useful reading: the number changes when the user reloads onto a
 * new build, which is exactly the event they want to notice.
 */
export function AppVersion() {
  return <p className="app-version">{formatVersion(config.appVersion)}</p>;
}
